export const customers = [
    { 
        id: 1, 
        username: 'bruno.v', 
        email: 'bruno@company.com', 
        firstName: 'Bruno', 
        lastName: 'Vespa', 
        middleName: '',
        storeId: 2,  
        walletBalance: 5255, 
        revenue: 3450,
        billing: { 
            firstName: 'Bruno', 
            lastName: 'Vespa', 
            middleName: '',
            company: 'Company 1', 
            email: 'bruno@company.com',
            phone: '(415) 231-0332',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    },
    { 
        id: 2, 
        username: 'andy.79', 
        email: 'warhol@gmail.com', 
        firstName: 'Andy', 
        lastName: 'Warhol', 
        middleName: '',
        storeId: 1,  
        walletBalance: 8055, 
        revenue: 7200,
        billing: { 
            firstName: 'Andy', 
            lastName: 'Warhol', 
            middleName: '',
            company: 'Company 1', 
            email: 'warhol@gmail.com',
            phone: '(212) 457-2308',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    },
    { 
        id: 3, 
        username: 'pretty', 
        email: 'ashley@gmail.com', 
        firstName: 'Ashley', 
        lastName: 'Ahlberg', 
        middleName: '',
        storeId: 1,  
        walletBalance: 17200, 
        revenue: 2200,
        billing: { 
            firstName: 'Ashley', 
            lastName: 'Ahlberg', 
            middleName: '',
            company: 'Company 5', 
            email: 'ashley@gmail.com',
            phone: '(212) 457-2308',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    },
    { 
        id: 4, 
        username: 'julia.a', 
        email: 'julia@gmail.com', 
        firstName: 'Julia', 
        lastName: 'Aniston', 
        middleName: '',
        storeId: 2,  
        walletBalance: 9480, 
        revenue: 1470,
        billing: { 
            firstName: 'Julia', 
            lastName: 'Aniston', 
            middleName: '',
            company: 'Company 5', 
            email: 'julia@gmail.com',
            phone: '(212) 457-2308',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    },
    { 
        id: 5, 
        username: 'lusia.m', 
        email: 'lusia@gmail.com', 
        firstName: 'Lusia', 
        lastName: 'Manuel', 
        middleName: '',
        storeId: 1,  
        walletBalance: 6200, 
        revenue: 3250,
        billing: { 
            firstName: 'Lusia', 
            lastName: 'Manuel', 
            middleName: '',
            company: 'Company 4', 
            email: 'lusia@gmail.com',
            phone: '(212) 457-2308',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    },
    { 
        id: 6, 
        username: 'adam.s', 
        email: 'adam@gmail.com', 
        firstName: 'Adam', 
        lastName: 'Sandler', 
        middleName: '',
        storeId: 2,  
        walletBalance: 7580, 
        revenue: 2950,
        billing: { 
            firstName: 'Adam', 
            lastName: 'Sandler', 
            middleName: '',
            company: 'Company 1', 
            email: 'adam@gmail.com',
            phone: '(212) 457-2308',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    },
    { 
        id: 7, 
        username: 'tereza.s', 
        email: 'tereza@gmail.com', 
        firstName: 'Tereza', 
        lastName: 'Stiles', 
        middleName: '',
        storeId: 2,  
        walletBalance: 5240, 
        revenue: 1095,
        billing: { 
            firstName: 'Tereza', 
            lastName: 'Stiles', 
            middleName: '',
            company: 'Company 3', 
            email: 'tereza@gmail.com',
            phone: '(212) 457-2308',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    },
    { 
        id: 8, 
        username: 'michael.b', 
        email: 'michael@gmail.com', 
        firstName: 'Michael', 
        lastName: 'Blair', 
        middleName: '',
        storeId: 2,  
        walletBalance: 7340, 
        revenue: 4580,
        billing: { 
            firstName: 'Michael', 
            lastName: 'Blair', 
            middleName: '',
            company: 'Company 3', 
            email: 'michael@gmail.com',
            phone: '(212) 457-2308',
            country: {name: 'United States', code: 'US'},
            city: 'Los Angeles',
            state: 'California',
            zip: '90201',
            address: 'Palos Verdes Peninsula'
        } 
    }
]